
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-neon-filter",
      function () {
        return require("private-next-pages/ai-neon-filter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-neon-filter"])
      });
    }
  